
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.172 0v3.628h.244c.57 0 1.102.214 1.462.544.42.09.78.324 1.05.684.57.81.422 1.986.272 2.616.06.21.122.446.122.656 0 .54-.268.934-.478 1.144-.12.36-.332.714-.572.984v.188c.15.09.51.238.75.328.81.3 1.95.716 2.4 1.856h4.35V3.15L10.594 0H4.172zm6.3.722L13.078 3.3h-2.606V.722zM4.416 4.2c-.81.03-1.41.27-1.8.75-.42.57-.512 1.444-.272 2.494a.963.963 0 00-.178.562c.06.48.27.788.45.938.12.45.416.832.656 1.012v.394l.122.056c.3.18.84.394 1.05.394.21 0 .684-.206.984-.356l.216-.122V9.994c.27-.21.538-.6.628-1.05.18-.15.422-.456.422-.816 0-.24-.06-.448-.15-.628.12-.42.388-1.586-.122-2.306-.15-.21-.394-.428-.844-.488-.24-.3-.682-.506-1.162-.506zm-1.322 6.694c-.21.15-.54.262-.9.412-.93.36-2.104.784-2.194 2.194 0 .09.034.146.094.206.03.06.088.094.178.094h3.6v-.3c0-.87.478-1.65.478-1.65l-.234-.506a5.44 5.44 0 01-.966-.422l-.056-.028zm2.784 0l-.112.056c-.09.06-.548.274-.938.394l-.234.506s.506.78.506 1.65v.3h3.6a.307.307 0 00.3-.3c-.12-1.41-1.292-1.864-2.222-2.194-.36-.12-.69-.262-.9-.412z"}})])
          )
        }
      }
    